import { render, staticRenderFns } from "./copy-pos-cate.vue?vue&type=template&id=2f578578"
import script from "./copy-pos-cate.vue?vue&type=script&lang=js"
export * from "./copy-pos-cate.vue?vue&type=script&lang=js"
import style0 from "./copy-pos-cate.vue?vue&type=style&index=0&id=2f578578&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports